/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/teacher.scss';
import PopFirstClassReport from '../../student/_PopFirstClassReport';
import MonthlySchedule from '../../../component/teacher/MonthlySchedule';
function AssignManage() {
  const [modalFirstClassReport, setModalFirstClassReport] = useState(false);
  return (
    <main className="com_container p_teacher_assign_manage_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_3 ">
            배정관리 <span className="bar" />
            <span className="point_txt">홍교사103ㆍ수학</span>
          </h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalFirstClassReport(true)} className="com_btn orange s btn_plus">
              첫 수업 보고서 작성
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <MonthlySchedule />
          </div>
        </section>
      </div>
      <PopFirstClassReport open={modalFirstClassReport} close={() => setModalFirstClassReport(false)} />
    </main>
  );
}

export default AssignManage;
